export var ToolbarType = /*#__PURE__*/function (ToolbarType) {
  ToolbarType["PRIMARY"] = "primaryToolbar";
  ToolbarType["FLOATING"] = "floatingToolbar";
  return ToolbarType;
}({});